/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.08.2016.
 */

export const ADD_TO_FAVORITES = 'add-asset-to-favorites';
export const REMOVE_FROM_FAVORITES = 'remove-asset-from-favorites';
export const GET_FAVORITES = 'get-favorites';

export function AddToFavorites(assetId) {

  return {
    type: ADD_TO_FAVORITES,
    meta: {
      key: assetId
    },
    payload: lh.favorites.addToFavorites(assetId)
  }
}

export function RemoveFromFavorites(assetId) {

  return {
    type: REMOVE_FROM_FAVORITES,
    meta: {
      key: assetId
    },
    payload: lh.favorites.removeFromFavorites(assetId)
  }
}

export function GetFavorites() {
  let Q;

  Q = lh.favorites.getFavorites();

  return {
    type: GET_FAVORITES,
    payload: Q
  }
}



// WEBPACK FOOTER //
// ./src/actions/favorites/actions-favorites.js